import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { validateField } from '../index.js';

export const EditMaterialTypeSchema = T.Object({
  uuid: T.String({ format: 'uuid', error: 'Uuid do material é um campo obrigatório' }),
  name: T.String({ minLength: 1, error: 'Nome do material é um campo obrigatório' }),
  brand: T.String({ format: 'uuid' }),
  multibrandBrands: T.Optional(T.Array(T.String({ format: 'uuid' })), true),
  categoryUuid: T.String({ format: 'uuid', error: 'Uuid do categoria é um campo obrigatório' }),
  observation: T.Optional(T.String()),
  active: T.Boolean({ error: 'Status é obrigatório' }),
  fileType: T.Optional(T.String({ error: 'Imagem é obrigatória' })),
  /** Pre-uploaded image key from image.uploadCompressed endpoint */
  imageKey: T.Optional(T.String()),
});

export type EditMaterialTypeInputType = typeof EditMaterialTypeSchema.static;

export async function ValidateEditMaterialTypeInput(value: unknown): Promise<EditMaterialTypeInputType> {
  return Value.Parse(EditMaterialTypeSchema, value);
}

export function checkMaterialTypeEditInput(field: string, value: unknown): string | boolean {
  return validateField(EditMaterialTypeSchema, field, value);
}
